module.exports = __webpack_public_path__ + "img/knowledge.e72582f4.png";